import random from 'lodash/random'

const nodes: any = {
  56: ['https://bsc-dataseed1.ninicoin.io', 'https://bsc-dataseed1.defibit.io', 'https://bsc-dataseed.binance.org'],
  97: ['https://data-seed-prebsc-1-s1.binance.org:8545', 'https://data-seed-prebsc-2-s1.binance.org:8545', 'https://data-seed-prebsc-1-s2.binance.org:8545',
      'https://data-seed-prebsc-2-s2.binance.org:8545', 'https://data-seed-prebsc-1-s3.binance.org:8545', 'https://data-seed-prebsc-2-s3.binance.org:8545']
}
const getBlockNode = (chainId: number) => {
  const ary = nodes[chainId]
  const randomIndex = random(0, ary.length - 1)
  return ary[randomIndex]
}
export default getBlockNode
